class Dropdown {
	constructor(el) {
		this.root = el;
		this.toggle = el.querySelector('.dropdown__toggle');
		this.panel = el.querySelector('.dropdown__panel');

		this.toggle.addEventListener('click', () => this.#toggle());

		document.addEventListener('click', (e) => {
			if (!this.root.contains(e.target)) this.#close();
		});

		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape') this.#close();
		});
	}

	#open() {
		this.root.classList.add('dropdown--open');
		this.toggle.setAttribute('aria-expanded', 'true');
		this.panel.setAttribute('aria-hidden', 'false');
	}

	#close() {
		this.root.classList.remove('dropdown--open');
		this.toggle.setAttribute('aria-expanded', 'false');
		this.panel.setAttribute('aria-hidden', 'true');
	}

	#toggle() {
		this.root.classList.contains('dropdown--open')
			? this.#close()
			: this.#open();
	}
}

document.querySelectorAll('.dropdown').forEach((el) => new Dropdown(el));